var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectInfoTableContentBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5472 0C28.4685 0 36.5 8.0315 36.5 18.0472C36.5 27.9685 28.4685 36 18.5472 36C8.5315 36 0.5 27.9685 0.5 18.0472C0.5 8.0315 8.5315 0 18.5472 0ZM21.5709 24.9449H20.626V15.2126C20.626 14.6457 20.1535 14.1732 19.5866 14.1732H15.4291C14.8622 14.1732 14.3898 14.6457 14.3898 15.2126V17.3858C14.3898 17.9528 14.8622 18.4252 15.4291 18.4252H16.2795V24.9449H15.4291C14.8622 24.9449 14.3898 25.4173 14.3898 25.9843V28.063C14.3898 28.6299 14.8622 29.1024 15.4291 29.1024H21.5709C22.1378 29.1024 22.6102 28.7244 22.6102 28.063V25.9843C22.6102 25.4173 22.1378 24.9449 21.5709 24.9449ZM18.2638 6.89764C19.6811 6.89764 20.815 8.0315 20.815 9.44882C20.815 10.8661 19.6811 12 18.2638 12C16.8465 12 15.7126 10.8661 15.7126 9.44882C15.7126 8.0315 16.8465 6.89764 18.2638 6.89764Z",
    fill: "#467077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInfoTableContentBlockIcon);
export default __webpack_public_path__ + "static/media/project-info-table-content-block-icon.dbf761ccd3197e2b0b3d68dc4fb940bb.svg";
export { ForwardRef as ReactComponent };